import React from 'react';
import { Section } from './Section';
import { Flower2 } from 'lucide-react';
export function Gancho() {
  return <Section className="bg-cream-light relative overflow-hidden rounded-3xl my-12" delay={0.2} data-id="element-82">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-brush-sage opacity-30 pointer-events-none" data-id="element-83"></div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-84">
        <Flower2 className="w-8 h-8 text-sage mx-auto mb-8 opacity-70" data-id="element-85" />

        <h2 className="text-3xl md:text-4xl font-serif mb-8 leading-relaxed" data-id="element-86">
          Diste lo más grande que una mujer puede dar.
          <br data-id="element-87" />
          <span className="text-rose-dark italic" data-id="element-88">Diste vida.</span>
        </h2>

        <div className="space-y-6 text-lg text-brown-light" data-id="element-89">
          <p data-id="element-90">Y sin embargo... hay algo que nadie te advirtió.</p>
          <p data-id="element-91">
            Que después de ese momento tan esperado, tan hermoso, tan
            poderoso... podrías despertar sintiéndote más perdida que nunca.
          </p>
          <p data-id="element-92">
            Con el cuerpo hinchado. Con la energía por el suelo. Con una mezcla
            extraña de amor inmenso por tu bebé y un vacío dentro de ti que no
            sabes cómo explicar.
          </p>
          <p className="font-medium text-brown" data-id="element-93">
            Y lo más duro no es el cansancio físico.
          </p>
          <p className="text-2xl font-serif text-rose-dark italic mt-8" data-id="element-94">
            Lo más duro es mirar al espejo y no reconocerte.
          </p>
        </div>
      </div>
    </Section>;
}